import { createContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
    const [cart, setCart] = useState({ items: [] });
    const [loading, setLoading] = useState(false);

    const fetchCart = useCallback(async () => {
        try {
            setLoading(true);
            const token = localStorage.getItem("authToken");
            if (!token) {
                setCart({ items: [] });
                return;
            }

            const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/cart`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            setCart(response.data || { items: [] });
        } catch (err) {
            console.error("Błąd pobierania koszyka:", err);
            setCart({ items: [] });
        } finally {
            setLoading(false);
        }
    }, []);

    // NOWE: Funkcja do aktualizacji ilości
    const updateItemQuantity = async (productId, quantity) => {
        const token = localStorage.getItem("authToken");
        if (!token) return { success: false, message: '⚠️ Musisz być zalogowany, aby wykonać tę akcję' };

        try {
            await axios.put(
                `${process.env.REACT_APP_API_URL}/api/cart/update/${productId}`,
                { productId, quantity },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            await fetchCart();
            return { success: true, message: '✔️ Zaktualizowano ilość produktu' };
        } catch (error) {
            console.error('Błąd podczas zmiany ilości:', error);
            return { success: false, message: '❌ Wystąpił błąd podczas zmiany ilości produktu' };
        }
    };

    // NOWE: Funkcja do usuwania pojedynczego produktu
    const removeFromCart = async (productId) => {
        const token = localStorage.getItem("authToken");
        if (!token) return { success: false, message: '⚠️ Musisz być zalogowany, aby wykonać tę akcję' };

        try {
            await axios.delete(`${process.env.REACT_APP_API_URL}/api/cart/remove/${productId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            await fetchCart();
            return { success: true, message: 'ℹ️ Produkt usunięty z koszyka' };
        } catch (err) {
            console.error('Błąd usuwania z koszyka:', err);
            return { success: false, message: '❌ Wystąpił błąd podczas usuwania produktu' };
        }
    };

    // NOWE: Funkcja do czyszczenia całego koszyka
    const clearCart = async () => {
        const token = localStorage.getItem("authToken");
        if (!token) return { success: false, message: '⚠️ Musisz być zalogowany, aby wykonać tę akcję' };

        try {
            // Uwaga: Jeśli masz dedykowany endpoint np. /api/cart/clear, 
            // warto go tu użyć zamiast pętli dla lepszej optymalizacji.
            for (const item of cart.items) {
                await axios.delete(`${process.env.REACT_APP_API_URL}/api/cart/remove/${item.product._id}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
            }
            await fetchCart();
            return { success: true, message: '🗑️ Koszyk został wyczyszczony' };
        } catch (err) {
            console.error('Błąd czyszczenia koszyka:', err);
            return { success: false, message: '❌ Wystąpił błąd podczas czyszczenia koszyka' };
        }
    };

    useEffect(() => {
        fetchCart(); 
    }, [fetchCart]);

    return (
        <CartContext.Provider value={{ 
            cart, setCart, fetchCart, loading, 
            updateItemQuantity, removeFromCart, clearCart 
        }}>
            {children}
        </CartContext.Provider>
    );
};